<script>
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import EditIcon from "../../icons/EditIcon.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import {axiosArticles} from "../../../helpers/axios_requests";
import TextareaEditor from "../../small_components/TextareaEditor.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../../small_components/DefaultButton.vue";
import SmallTitle from "../../small_components/SmallTitle.vue";
import DefaultBox from "../../slots/DefaultBox";

export default {
  name: 'ArticlesView',
  components: {
    SmallTitle,
    DefaultButton,
    ValidationObserver,
    DefaultSelect, TextareaEditor, DefaultTitle, EditIcon, BadgeBlock, DefaultInput, RouterLinkTo, DefaultBox},
  mixins: [routes_mixin],

  data() {
    return {
      getUserRoleIsAdmin: true,
      new_article: false,
      loading: true,
      article: [],
      categories: [],
      selectedCategory: [],
    }
  },

  created() {
    this.loading = false;
    this.fetchArticle(this.get_id())
  },

  methods: {
    fillData(data) {
      this.article = data || []
      if (data.category) {
        this.selectedCategory = data.category
      }
    },

    fetchArticle(id) {
      this.loading = true
      axiosArticles.get(id)
          .then(r => {
            this.fillData(r.data.article)
          })
          .finally(() => {
            this.loading = false
          })
    },

    get_id() {
      return Number(this.$route.params.id)
    },
  }
}
</script>

<template>
  <div class="article-component">
    <badge-block>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ article.title }}</h5>
              <div class="card-body">
                  <div class="row mt-20">
                    <div class="col-md-12 col-12 mb-10">
                      <default-title
                          label="Title"
                          :text="article.title"
                      />
                    </div>
                    <div class="col-md-12 col-12 mb-10">
                      <small-title
                          label="Subtitle"
                          :text="article.subtitle"
                      />
                    </div>
                    <div class="col-md-12 col-12 mb-10">
                      <template>
                        <p v-html="article.body"></p>
                        <template v-if="article.image">
                          <div class="article-component-user-image-block">
                            <img :src="article.image" :alt="article.title" >
                          </div>
                        </template>

                      </template>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>
